import CustomButton from "components/CustomButton/CustomButton";
import { Column } from "components/styles";
import ListIcon from "icons/ListIcon";
import ReasignationIcon from "icons/ReasignationIcon";
import StopIcon from "icons/StopIcon";

const ActionButtons = ({
    disabled,
    searchAvailableResource,
    cancelReservation,
    changeToListStudentReservationView,
    isManual, isGroupRoom
}) => {
    return (
        <Column gap="12px">
            <CustomButton
                width="100%"
                icon={<ReasignationIcon/>} 
                text="Reasignar reserva"
                disabled={disabled}
                onClick={searchAvailableResource}/>
            <CustomButton 
                width="100%"
                icon={<StopIcon/>} 
                variant="secondary"
                text="Cancelar reserva"
                disabled={disabled}
                onClick={cancelReservation}/>
            {(!isManual && isGroupRoom) && 
            <CustomButton 
                width="100%"
                icon={<ListIcon/>} 
                variant="secondary"
                text="Listado de alumnos"
                onClick={changeToListStudentReservationView}/>}
        </Column>
    );
}

export default ActionButtons;